import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { first } from 'rxjs/operators'
import { Cry } from './cry.service'
import { GlobalService } from './global.service'
import { openFirestoreActionUrl } from './new-api.util'
import { StyleLoader } from './style.loader'

declare var window: any
let PROGRAMDEF: any
let env: any

@Injectable()
export class AppInitService {

  constructor(
    private httpClient: HttpClient,
    private g: GlobalService,
    private styleLoader: StyleLoader
  ) {
    env = (window as any).y4wenvs.ENV
    PROGRAMDEF = (window as any).y4wenvs.PROGRAMDEF
    this.getGlobals()
    console.info(`## ${this.constructor.name}`)
  }

  private getGlobals() {
    let host = window.location.href || null
    const boNick = Cry.getLocal('bo-nick', false)
    host = host !== null ? host.replace('https://', '').replace('http://', '') : null

    // Check if running on localhost (handles admin.localhost, localhost, etc.)
    const isLocalhost = host && (host.indexOf('localhost') > -1 || host.indexOf('192.') === 0)

    // Extract nick - first segment of hostname
    let nick = host.split('.')[0] || 'yesmkt'

    // For localhost, get nick from body dataset instead of hostname
    if (isLocalhost && document) {
      nick = (document as any).body.dataset.nick || nick
    }

    // Normalize special nicks
    if (nick === 'backoffice') nick = 'admin'
    if (nick === 'yes4cinema') nick = 'cinemacity'

    // bo-nick from localStorage overrides everything (for centralized backoffice program switching)
    if (boNick) nick = boNick

    // Fix: Clear cached program if bo-nick changed the program selection
    // This ensures init() fetches fresh program data instead of using stale cache
    const cachedProgram = Cry.get('program', true)
    if (cachedProgram && cachedProgram.nick && cachedProgram.nick !== nick) {
      Cry.remove('program')
      Cry.remove('type')
      Cry.remove('access')
    }

    // projectID now comes from HTML, generated at build
    const projectId = document.body.dataset.projectId || 'yes4eutests' // 'yes4eu'
    window.projectId = projectId
    const url = 'https://firestore.googleapis.com/v1/projects'
    Cry.set('url', url, true)
    Cry.set('projectId', projectId, true)
    Cry.set('nick', nick, true)
    // For backend API, use nick as host (not the domain prefix like 'admin')
    Cry.set('host', nick, true)
    Cry.set('isLocal', window.location.port === "4600")
    Cry.set('native', false)
    if (host.indexOf('localhost') > -1 && window.location.port === "4600" && localStorage.getItem('localApi') === null) localStorage.setItem('localApi', 'false')
    return { url, projectId, nick, host: nick }
  }

  init(): Promise<any> {
    const dt = new Date
    // ### necessary for the native app
    this.loadNativeGlobals()

    const nick = Cry.get('nick', true)
    const host = Cry.get('host', true)
    const type = Cry.get('type', true)
    const projectId = Cry.get('projectId', true)
    const region = env.region || 'europe-west3'
    const program = Cry.get('program', true)
    const port = ((window as any).location.port)
    let apiUrl = `https://${region}-${projectId}.cloudfunctions.net`
    const localApi = localStorage.getItem('localApi') ? JSON.parse(localStorage.getItem('localApi')) : true
    if (['4500', '4600', '4700'].includes(port) && localApi) {
      apiUrl = `http://localhost:5001/${projectId}/${region}`
    }
    this.g.set('apiUrl', Cry.get('apiUrl') || apiUrl)

    // New API (v2) base URL — custom domain per Firebase project
    const NEW_API_URLS: Record<string, string> = {
      yes4eutests: 'https://devapi.yesmktg.net',
      yes4eupp: 'https://ppapi.yesmkt.net',
      yes4eu: 'https://api.yesmkt.com',
    }
    const newApiUrl = localStorage.getItem('newApiUrlOverride')
      ? JSON.parse(localStorage.getItem('newApiUrlOverride'))
      : NEW_API_URLS[projectId] || NEW_API_URLS['yes4eutests']
    this.g.set('newApiUrl', newApiUrl)
    // Direct Cloud Functions URL of the `backend` function. Long-running calls (e.g. verifyExpire)
    // use it because Firebase Hosting, which fronts `newApiUrl`, cuts every request at 60s.
    this.g.set('longRunningApiUrl', `${this.g.get('apiUrl')}/backend`)

    this.httpClient.post(openFirestoreActionUrl(apiUrl, newApiUrl), Cry.crypt(JSON.stringify({ action: 'menus', nick: 'yes' }), true)).pipe(first()).toPromise().then(_menus => {
      const menus = JSON.parse(Cry.decrypt(_menus as string, true))
      Cry.set('menus', menus, true)
    })

    if (Cry.get('pt-PT', false)) this.g.set('pt-PT', Cry.get('pt-PT', false))
    if (Cry.get(`pt-${nick}`, false)) this.g.set(`pt-${nick}`, Cry.get(`pt-${nick}`, false))

    if (Cry.get('program')) {
      window['timings'].push({ time: new Date().getTime(), name: 'app.init started' })
      this.g.set('program', program)
      this.g.set('type', type)
      this.g.set('nick', program.nick)
      this.g.set('access', Cry.get('access'))
      if (Cry.get('isLocal')) this.styleLoader.loadStyle(nick) //  || Cry.get('native')
      else this.styleLoader.loadStyle(nick, program.cssUrl)
    } else {
      const url = Cry.get('url')
      window['timings'].push({ time: new Date().getTime(), name: 'app.init fetching program' })
      const promise = this.httpClient.post(openFirestoreActionUrl(apiUrl, newApiUrl), Cry.crypt(JSON.stringify({ action: 'program', nick, host }), true)).pipe(first())
        .toPromise()
        .then((res: string) => {
          window['timings'].push({ time: new Date().getTime(), name: 'app.init fetched program' })
          const _program = JSON.parse(Cry.decrypt(res, true))
          if (_program && _program.name) {
            window['timings'].push({ time: new Date().getTime(), name: 'app.init program fetched' })
            this.g.set('program', _program); Cry.set('program', _program, true)
            this.g.set('type', _program.type); Cry.set('type', _program.type)
            this.g.set('access', _program.access); Cry.set('access', _program.access)
            this.g.set('nick', _program.nick)
            if (_program.campaigns) {
              this.g.set('campaigns', _program.campaigns)
              this.g.set('campaign', _program.campaigns[nick])
            }
            if (Cry.get('isLocal')) this.styleLoader.loadStyle(_program.nick || Cry.get('nick'))
            else this.styleLoader.loadStyle(_program.nick || Cry.get('nick'), (_program || Cry.get('program', true))['cssUrl'])
          }
        }).catch(err => {
          console.log('# ERROR', err.message)
        })
      return promise
    }
  }

  /**
   * Method that loads the pre-defined data for a native app
   * @private
   */
  private loadNativeGlobals() {
    const progdef = PROGRAMDEF || null
    if (progdef) {
      Cry.set('isLocal', progdef.isLocal)
      Cry.set('native', progdef.native)
      Cry.set('nick', progdef.nick)
      Cry.set('projectId', progdef.projectId)
      Cry.set('projectName', progdef.projectName)
      Cry.set('apiUrl', progdef.apiUrl)

      this.g.set('native', progdef.native)
      this.g.set('isLocal', progdef.isLocal)
    }
  }

}
